import { Features, type FeatureName } from '../types/features';
import type { ToolConfig } from '../contexts/TenantConfigContext';

export const STATIC_TOOL_CONFIGS: Partial<Record<FeatureName, ToolConfig>> = {
  [Features.MATTERS]: {
    description: 'Manage RAF claim matters — upload documents, extract fields, generate forms.',
    documentGuidance: {
      title: 'What to Upload',
      shortDescription: 'Upload consultation notes, police reports, medical records, or any RAF claim documentation.',
      acceptedFormats: ['PDF', 'DOCX', 'JPG', 'PNG'],
      recommendedDocuments: [
        'Consultation notes or instructions from the claimant',
        'Police accident report (SAP 308)',
        'Medical records and hospital documentation',
        'ID documents and proof of income',
      ],
      tips: [
        'Upload all available documents at once for the most complete field extraction.',
        'Use Intelligent Mode for cleaner normalisation of messy handwritten notes.',
      ],
    },
  },
};
